export const splitName = (fullName: string) => {
  const [firstName = '', ...lastNameParts] = fullName.trim().split(/\s+/);
  const lastName = lastNameParts.join(' ');
  return { firstName: firstName || '', lastName: lastName || '' };
};
